import * as moment from 'moment-timezone';

export function formatarData(data, formato) {
  var timezone = 'America/Sao_Paulo';
  return moment(data).tz(timezone).format(formato);
}
